import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3b94e836"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "input-field-content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ProsemirrorViewerFormInput = _resolveComponent("ProsemirrorViewerFormInput");
    const _component_FriedFieldSet = _resolveComponent("FriedFieldSet");
    const _component_ProsemirrorViewerFormEmailInput = _resolveComponent("ProsemirrorViewerFormEmailInput");
    const _component_InputDate = _resolveComponent("InputDate");
    const _component_InputCheckbox = _resolveComponent("InputCheckbox");
    const _component_InputDropdown = _resolveComponent("InputDropdown");
    const _directive_tooltip = _resolveDirective("tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.input.inputSettings.type === _ctx.FieldInputType.Text)
            ? (_openBlock(), _createBlock(_component_FriedFieldSet, {
                key: 0,
                class: "text-input-container",
                error: _ctx.hasUpdateError(_ctx.input.id)
            }, {
                default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_ProsemirrorViewerFormInput, {
                        id: _ctx.input.id,
                        class: "input-default-text",
                        "field-focused": _ctx.hasFocus,
                        "data-external": "form-input-text-input-view",
                        content: _ctx.getInputContent(_ctx.getTextValue(_ctx.input, _ctx.recipientInput), _ctx.fields),
                        "merge-values": _ctx.mergeValues,
                        fields: _ctx.fields,
                        bold: false,
                        italic: false,
                        underline: false,
                        superscript: false,
                        label: false,
                        link: false,
                        editable: _ctx.editable,
                        "is-updating": _ctx.isUpdatingInputValue(_ctx.input.id),
                        onUpdate: _cache[0] || (_cache[0] = ($event) => (_ctx.handleInputUpdate($event, _ctx.input)))
                    }, null, 8, ["id", "field-focused", "content", "merge-values", "fields", "editable", "is-updating"]), [
                        [_directive_tooltip, _ctx.getTooltip(_ctx.input)]
                    ])
                ]),
                _: 1
            }, 8, ["error"]))
            : (_ctx.input.inputSettings.type === _ctx.FieldInputType.Email)
                ? _withDirectives((_openBlock(), _createBlock(_component_ProsemirrorViewerFormEmailInput, {
                    key: 1,
                    id: _ctx.input.id,
                    "data-external": "form-input-email-input-view",
                    "has-update-error": _ctx.hasUpdateError(_ctx.input.id),
                    "field-focused": _ctx.hasFocus,
                    "input-field": _ctx.input,
                    "recipient-input": _ctx.getRecipientInputField(_ctx.input.id, _ctx.recipientInput),
                    "merge-values": _ctx.mergeValues,
                    fields: _ctx.fields,
                    editable: _ctx.editable,
                    "is-required": _ctx.input.inputSettings.required,
                    "is-updating": _ctx.isUpdatingInputValue(_ctx.input.id),
                    onUpdate: _cache[1] || (_cache[1] = ($event) => (_ctx.handleInputUpdate($event, _ctx.input))),
                    onValidateFormInput: _cache[2] || (_cache[2] = ($event) => (_ctx.validateFormInputField($event)))
                }, null, 8, ["id", "has-update-error", "field-focused", "input-field", "recipient-input", "merge-values", "fields", "editable", "is-required", "is-updating"])), [
                    [_directive_tooltip, _ctx.getTooltip(_ctx.input)]
                ])
                : (_ctx.input.inputSettings.type === _ctx.FieldInputType.Date)
                    ? _withDirectives((_openBlock(), _createBlock(_component_InputDate, {
                        key: 2,
                        "has-update-error": _ctx.hasUpdateError(_ctx.input.id),
                        "field-focused": _ctx.hasFocus,
                        "input-field": _ctx.input,
                        "recipient-input": _ctx.getRecipientInputField(_ctx.input.id, _ctx.recipientInput),
                        "merge-values": _ctx.mergeValues,
                        fields: _ctx.fields,
                        editable: _ctx.editable,
                        "is-updating": _ctx.isUpdatingInputValue(_ctx.input.id),
                        onUpdate: _cache[3] || (_cache[3] = ($event) => (_ctx.handleInputUpdate($event, _ctx.input)))
                    }, null, 8, ["has-update-error", "field-focused", "input-field", "recipient-input", "merge-values", "fields", "editable", "is-updating"])), [
                        [_directive_tooltip, _ctx.getTooltip(_ctx.input)]
                    ])
                    : (_ctx.input.inputSettings.type === _ctx.FieldInputType.Checkbox)
                        ? _withDirectives((_openBlock(), _createBlock(_component_InputCheckbox, {
                            key: 3,
                            editable: _ctx.editable,
                            fields: _ctx.fields,
                            "field-focused": _ctx.hasFocus,
                            input: _ctx.input,
                            "is-pdf-viewer": _ctx.isPdfViewer,
                            checked: _ctx.getCheckboxValue(_ctx.input, _ctx.recipientInput),
                            "merge-values": _ctx.mergeValues,
                            "has-update-error": _ctx.hasUpdateError(_ctx.input.id),
                            "is-updating": _ctx.isUpdatingInputValue(_ctx.input.id),
                            onUpdateChecked: _cache[4] || (_cache[4] = ($event) => (_ctx.handleCheckboxUpdate($event, _ctx.input.id)))
                        }, null, 8, ["editable", "fields", "field-focused", "input", "is-pdf-viewer", "checked", "merge-values", "has-update-error", "is-updating"])), [
                            [_directive_tooltip, _ctx.getTooltip(_ctx.input)]
                        ])
                        : (_ctx.input.inputSettings.type === _ctx.FieldInputType.Dropdown)
                            ? (_openBlock(), _createBlock(_component_InputDropdown, {
                                key: 4,
                                tooltip: _ctx.getTooltip(_ctx.input),
                                editable: _ctx.editable,
                                fields: _ctx.fields,
                                "field-focused": _ctx.hasFocus,
                                input: _ctx.input,
                                "is-pdf-viewer": _ctx.isPdfViewer,
                                "recipient-input": _ctx.recipientInput,
                                "merge-values": _ctx.mergeValues,
                                "has-update-error": _ctx.hasUpdateError(_ctx.input.id),
                                "is-updating": _ctx.isUpdatingInputValue(_ctx.input.id),
                                onUpdateSelected: _cache[5] || (_cache[5] = ($event) => (_ctx.updateValue({ value: $event, inputId: _ctx.input.id })))
                            }, null, 8, ["tooltip", "editable", "fields", "field-focused", "input", "is-pdf-viewer", "recipient-input", "merge-values", "has-update-error", "is-updating"]))
                            : _createCommentVNode("", true),
        (_ctx.input.inputSettings.helpText)
            ? (_openBlock(), _createBlock(_component_ProsemirrorViewerFormInput, {
                key: 5,
                class: "input-help-text",
                "data-external": "form-input-text-help-text-view",
                content: _ctx.getSafeText(_ctx.input.inputSettings.helpText),
                "merge-values": _ctx.mergeValues,
                fields: _ctx.fields,
                placeholder: ""
            }, null, 8, ["content", "merge-values", "fields"]))
            : _createCommentVNode("", true)
    ]));
}
